import React, {useRef, useEffect, useState} from "react";

export default function FileCard(props)
{
    let fileName = props.fileInfo.fileName;
    let fileType = props.fileInfo.fileType;
    let filePath = props.fileInfo.filePath;
    let snapshotFileName = props.fileInfo.snapshotFileName;
    let captureDate = props.fileInfo.captureDate;
    let uploadProgress = props.fileInfo.uploadProgress;
    let [isUploaded, setUploaded] = useState(props.fileInfo.uploaded);

    function UploadFile()
    {
        setUploaded(true);
        props.handleUpload();
    }

    function GetUploadStatus()
    {
        if(uploadProgress == 100)
        {
            return 'Uploaded!';
        }
        else
        {
            return uploadProgress + '%';
        }
    }

// Thumbnails need to be replaced and get from the server

    return(        
        <div className="fileCard">
                <img className='fileCardthumbnail' src={require('./assets/thumbnails/' + 'test.jpg')}/>

                <div className='fileCardMiddle'>
                    <div><p className="title">02122022_Capture01</p></div>

                    <div><img className="dateIcon" src={require('./assets/icons/' + 'time-white.png')}/> <span className="date">22/12/2022</span></div>

                    <div><button className="encapsulate">View Model</button></div>
                </div>
                
            {/* {!isUploaded ?
                (
                    <div className='fileCardRight'>
                        <button>View Model</button>
                    </div>
                ) : (                 
                    <div className='fileCardRight'>
                        <p>{GetUploadStatus()}</p>
                    </div>
                )} */}
        </div>
    )
}